module.exports = __webpack_public_path__ + "assets/img/ic-arrow-right.e5ac5cf9.svg";